export default __webpack_public_path__ + "static/media/reporting-iphone-content-demo.e3eb0240.png";